import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { DefaultResponse, GeneralLayout, SelectData } from '../../models';

@Injectable({
  providedIn: 'root',
})
export class GeneralLayoutService {
  constructor(private http: HttpClient) {}

  private readonly API = `${environment.api_url}/LayoutGeral`;

  getAll(): Observable<DefaultResponse<GeneralLayout>> {
    return this.http.get<DefaultResponse<GeneralLayout>>(`${this.API}/getAll`);
  }

  getLayoutSelectData(): Observable<SelectData[]> {
    return this.getAll().pipe(
      map((response) =>
        response.data.map((item) => ({
          label: item.nomeLayout,
          value: item.id,
        }))
      )
    );
  }
}
